<typography *ngIf="value || value === 0; else placeholderTpl">
  {{ value | rdrCurrency: (currencyFormat ? currencyFormat : 'default') }}
</typography>

<ng-template #placeholderTpl>
  <typography look="inputPlaceholder"> {{ placeholder }} </typography>
</ng-template>
